import { useAtom, useAtomValue } from "jotai";
import { ChangeEvent, FormEvent } from "react";

import { isVehicleConditionValidAtom } from "atoms/vehicleCondition/formValidation";
import { mileageAtom, mileageWarningAtom } from "atoms/vehicleCondition/mileage";
import { vehicleConditionAtom } from "atoms/vehicleCondition/questions";
import { useClientTranslation } from "hooks/useClientTranslation";
import { Locale } from "types/locale";
import { formatNumberIntl, removeNumberSeparators } from "utils/stringHelper";

import { NumberString, VehicleCondition } from "../types";
import { getMileageWarningTranslation } from "../utils/getMileageWarningTranslationKey";
import { isNumberString } from "../utils/isNumberString";

export const useVehicleConditionForm = (locale: Locale) => {
  const [mileage, setMileage] = useAtom(mileageAtom);
  const vehicleCondition = useAtomValue(vehicleConditionAtom);
  const isValid = useAtomValue(isVehicleConditionValidAtom);
  const [warning, setWarning] = useAtom(mileageWarningAtom);
  const { t } = useClientTranslation();

  const handleSubmit = (onSubmit: (data: VehicleCondition) => void) => (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(vehicleCondition);
  };

  const onType = ({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
    const mileage = removeNumberSeparators(currentTarget.value) as NumberString;

    const formattedMileage = mileage ? formatNumberIntl(mileage, locale) : "";

    setWarning(getMileageWarningTranslation(mileage, t));

    if (formattedMileage === "" || isNumberString(formattedMileage)) {
      setMileage(formattedMileage);
    }
  };

  return {
    onType,
    handleSubmit,
    isValid,
    warning,
    mileage,
  };
};
